import React, { useEffect, useState } from "react";
import MetaTags from "react-meta-tags";
import { admission } from "../config/api";

import { HiOutlineAcademicCap, HiOutlineUserGroup } from "react-icons/hi2";
import axios from "axios";
import NewsList from "../Components/NewsList";
import { InlineLoading } from "../Components/LoadingOverlay";
import imgDoctor from "../assets/bundit_l.png";
import imgMaster from "../assets/bundit_ll.png";
import "./Register.css";
// การ์ดเลือกระดับใช้คลาส .reg-rounds / .reg-round--bundit ร่วมกับหน้า Register
import "../Components/RegisterRounds/RegisterRounds.css";

const base = process.env.REACT_APP_BASENAME || "";

const bunditOptions = [
  {
    href: `${base}/Register/3`,
    src: imgMaster,
    alt: "สมัครเรียนระดับปริญญาโท",
  },
  {
    href: `${base}/Register/4`,
    src: imgDoctor,
    alt: "สมัครเรียนระดับปริญญาเอก",
  },
];

function Select_bundit() {
  const [News, setNews] = useState([]);
  const [loadingNews, setLoadingNews] = useState(true);

  useEffect(() => {
    axios
      .get(admission + "/administrator_new/show/3")
      .then((res) => {
        const data = res.data;
        if (data && data.length !== 0) {
          setNews(res.data);
        } else {
          setNews([]);
        }
      })
      .catch(() => setNews([]))
      .finally(() => setLoadingNews(false));
  }, []);

  return (
    <>
      <MetaTags>
        <title>เลือกระดับบัณฑิตศึกษา | มหาวิทยาลัยราชภัฏกำแพงเพชร</title>
        <meta
          name="description"
          content="สมัครเรียนระดับปริญญาโท - ปริญญาเอก มหาวิทยาลัยราชภัฏกำแพงเพชร"
        />
        <meta property="og:title" content="เลือกระดับบัณฑิตศึกษา" />
      </MetaTags>

      <div className="reg-page">
        <div className="reg-hero">
          <p className="reg-hero__eyebrow">มหาวิทยาลัยราชภัฏกำแพงเพชร</p>
          <h1 className="reg-hero__title">
            <HiOutlineAcademicCap size={28} aria-hidden />
            สมัครเรียนระดับบัณฑิตศึกษา
          </h1>
          <p className="reg-hero__desc">
            เลือกปริญญาโทหรือปริญญาเอกที่ต้องการสมัคร
          </p>
        </div>

        <div className="reg-panel">
          <h2 className="reg-panel__title">
            <HiOutlineUserGroup size={20} aria-hidden />
            เลือกรายการที่ต้องการ
          </h2>
          <p className="reg-panel__hint">กดที่ภาพเพื่อเข้าสู่ระบบสมัครเรียน</p>

          <div className="reg-rounds reg-rounds--bundit">
            {bunditOptions.map((item) => (
              <a
                key={item.href}
                href={item.href}
                className="reg-round reg-round--bundit"
              >
                <img src={item.src} alt={item.alt} />
              </a>
            ))}
          </div>
        </div>

        {loadingNews ? (
          <InlineLoading label="กำลังโหลดข่าวประชาสัมพันธ์..." />
        ) : News.length !== 0 ? (
          <NewsList items={News} previewCount={3} collapsible />
        ) : null}
      </div>
    </>
  );
}

export default Select_bundit;
